module.exports = __webpack_public_path__ + "static/media/H48103.21da8061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/handles/H48103.png
// module id = 90
// module chunks = 0